import Echo from "laravel-echo"
import { createApp, h } from 'vue'
import $bus from '@/Utils/eventBus'
import VueCookies from 'vue-cookies'
import protoExtends from '@/Utils/protoExtends'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { fpjsPlugin } from '@fingerprintjs/fingerprintjs-pro-vue-v3'

window.Pusher = require('pusher-js');
InertiaProgress.init()
protoExtends()

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    title: title => title ? `${title} | Reethi Foto Archives` : 'Reethi Foto Archives',
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
        app.config.globalProperties.$bus = $bus
        app.config.globalProperties.$route = route
        app.config.globalProperties.$echo = new Echo({
            broadcaster: 'pusher',
            key: window.PUSHER_APP_KEY,
            wsHost: window.APP_DEBUG ? window.location.hostname : 'socket.reethifoto.com',
            wsPort: window.APP_DEBUG ? 6001 : window.IS_SSL ? 443 : 80,
            wssPort: window.APP_DEBUG ? 6001 : window.IS_SSL ? 443 : 80,
            forceTLS: false,
            disableStats: true,
        });
        app.use(plugin).use(fpjsPlugin, {
            loadOptions: {
                apiKey: "zNXkhG9CEYYnMkEwaBYY",
                region: "ap"
            },
        }).use(VueCookies, { expires: '7d'}).mount(el)
    },
})
